<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import Pagination from "@/components/standard/Induction/components/InductionPagination";
import CheckModal from "@/components/CheckModal";
import Table from "@/components/standard/Induction/components/InductionTable";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import serviciosHigieneAPI from "@/services/standards/serviciosHigiene/serviciosHigieneAPI";
import CompanyAPI from "@/services/company/companyAPI";
import CompanySSOAPI from "@/services/sso/company/companySSO.API";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";
import Swal from "sweetalert2";
import ItemAPI from "@/services/items/itemsAPI";
import { dateFormat } from "@/utils/helpers/format";
import uploadDocument from "@/utils/digitalOcean/digitalocean-upload-file";
import ServiciosHigienePagination from "../../../components/standard/serviciosHigiene/ServiciosHigienePagination.vue";

/**
 * Basic Tables component
 */
export default {
  page: {
    title: "3.1.8 Servicios de higiene",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    Pagination,
    PageHeader,
    Table,
    CheckModal,
    ServiciosHigienePagination,
  },
  data() {
    return {
      title: "3.1.8 Servicios de higiene",
      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "3.1.8 Servicios de higiene",
          active: true,
        },
      ],
      list: [],
      themes: [],
      search: "",

      file: null,

      servicios: {
        hygiene_service: null,
        file: null,
        other: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },
      submitted: false,
      lastId: 1,
      company: null,

      companyID: this.$store.getters["company/getCompany"].id || null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      deleteCount: 0,
      loading1: true,
      item: null,
      itemStatus: "No cumplido",
      itemData: null,
    };
  },
  validations: {

  },
  methods: {
    fetch() {
      this.$refs.paginator.query();
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    getItemData() {
      ItemAPI.getItems(30)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    getFile(file) {
      try {
        const name = file.split("/");
        return name[name.length - 1];
      } catch (error) {
        return file;
      }
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/3.1.8/${this.lastId}/${this.file.name}`;
        } else {
          url = `sst-prod/${this.nit}/3.1.8/${this.lastId}/${this.file.name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.servicios.file = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    async save() {
      this.submitted = true;
      this.loading1 = true
      let response = await this.uploadDocument();
      if (response) {
        serviciosHigieneAPI.save(this.servicios)
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 30,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.sendNotification(59, 30, true);
                this.loading1 = false
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Se ha registrado con éxito!",
                    type: "success",
                    icon: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
              })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
          });

      } else {
        this.loading1 = false
        setTimeout(() => {
          Swal.fire({
            title: "¡Error!",
            text: "¡No se ha podido registrar!",
            type: "warning",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        }, 2000)
      }
    },

    getData() {
      CompanyAPI.getCompany(this.companyID || null)
        .then((response) => {
          CompanySSOAPI.getCompany(response.uuid)
            .then((r) => {
              this.company = r.nit;
              this.loading1 = false;
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 30)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    changeItemStatus(itemStatus) {
      const itemChange = {
        companies_id: this.companyID,
        item_id: 30,
        status: itemStatus,
      };
      newScoresAPI.calculateScores(itemChange)
        .then((response) => {
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha cambiado el estado del ítem con éxito!",
            icon: "success",
            type: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 2000)
        })
        .catch((error) => {
          Swal.fire({
            title: "¡ERROR!",
            text: "¡No se ha actualizado el estado del ítem!",
            icon: "error",
            type: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 2000)
          console.log(error);
        });
    },

    deleteEliminacion(id) {
      serviciosHigieneAPI
        .delete(id)
        .then((data) => {
          if (this.deleteCount > 0) {
            this.deleteCount -= 1;
          }
          const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';
          const itemChange = {
            companies_id: this.companyID,
            item_id: 30,
            status: newStatus,
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              this.loading1 = false
              setTimeout(() => {
                Swal.fire({
                  title: "É!",
                  text: "Se ha sido eliminado con éxito!",
                  type: "success",
                  icon: "success",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
            })
            .catch((error) => {
              this.loading1 = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getEliminacion() {
      serviciosHigieneAPI
        .getAll(this.companyID, '', '')
        .then((response) => {
          this.list = response.data.data;
          if (response.data.data[0]['id']) {
            this.lastId = response.data.data[0]['id'] + 1
          }
          if (Array.isArray(this.lista)) {
            this.deleteCount = this.lista.length;
          } else {
            this.deleteCount = 0;
          }
          this.loading1 = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    goBack() {
      this.$router.go(-1);
    },
  },

  mounted() {
    this.getData();
    this.getItems();
    this.getItemData();
    this.getEliminacion();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">
        <div v-if="!loading1">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12 pl-3">
                  <CheckModal>
                    <p class="text-justify">
                      Las empresas deben garantizar que cuenta con un suministro
                      permanente de agua potable, servicios sanitarios y
                      mecanismos para disponer excretas y basuras.
                    </p>
                    <p class="text-justify">
                      En la resolución 2400 de 1979 establece que todos los
                      lugares de trabajo deben tener o instalar un inodoro, un
                      lavamanos, un orinal y una ducha, en proporción de uno {1)
                      por cada quince (15) trabajadores, separados por sexos, y
                      dotados de todos los elementos indispensables para su
                      servicio, consistentes en papel higiénico, recipientes de
                      recolección, toallas de papel, jabón, desinfectantes y
                      desodorantes.
                    </p>
                    <p class="text-justify">
                      En este ítem, la empresa debe subir evidencias donde
                      demuestre el cumplimiento de estos requisitos.
                    </p>
                  </CheckModal>
                </div>
                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>

              <hr />
              <form class="form-group" @submit.prevent="save">
                <div class="form-row col-12 pt-2">
                  <b-form-group class="col-md-6 px-2" label="Servicio de higiene" label-for="theme">
                    <b-form-select :disabled="!allowAccess() || !getRole('Crear')" id="theme"
                      v-model="servicios.hygiene_service" required>
                      <b-form-select-option value="Disposición de agua potable">
                        Disposición de agua potable
                      </b-form-select-option>
                      <b-form-select-option value="Manejo de aguas residuales">
                        Manejo de aguas residuales
                      </b-form-select-option>
                      <b-form-select-option value="Cantidad de servicios sanitarios">
                        Cantidad de servicios sanitarios
                      </b-form-select-option>
                      <b-form-select-option value="Dotación de servicios sanitarios">
                        Dotación de servicios sanitarios
                      </b-form-select-option>
                      <b-form-select-option value="Otros ¿cuáles?">
                        Otros ¿cuáles?
                      </b-form-select-option>
                    </b-form-select>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Evidencia" label-for="Evidencia">
                    <b-form-file type="file" id="file" required ref="file" name="file" browse-text="Buscar" inline
                      :placeholder="`Selecciona un archivo...`" drop-placeholder="Suelta acá..." v-model="file"
                      @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>
                </div>

                <div v-if="servicios.hygiene_service === 'Otros ¿cuáles?'" class="form-row col-12">
                  <b-form-group class="col-md-12 px-2" label="Otro ¿Cuál?" label-for="description">
                    <b-form-textarea :disabled="!allowAccess() || !getRole('Crear')" id="description"
                      v-model="servicios.other" maxlength="200">
                    </b-form-textarea>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0 px-3 pt-2">
                  <button :disabled="submitted" type="submit" class="btn btn-primary mx-1">
                    Guardar
                  </button>
                  <button type="reset" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>
              </form>
              <hr class="px-2" />
              <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                <div class="col-lg-12">
                  <div class="card-body">
                    <div class="row pb-3">
                      <div class="col-6">
                        <form @submit.prevent="fetch()" class="form-inline">
                          <div class="form-group mr-2">
                            <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                              class="form-control px-2" placeholder="Buscar"></b-form-input>

                            <div class="col-1">
                              <button type="submit" class="btn btn-primary px-2">
                                Buscar
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                      <div class="col-6"></div>
                    </div>

                    <div class="table-responsive">
                      <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                        <thead class="table-active">
                          <tr>
                            <th class="text-left align-middle">Fecha</th>

                            <th class="text-left align-middle">
                              Servicio de higiene
                            </th>

                            <th class="text-center align-middle">Evidencia</th>
                            <th class="text-center align-middle">Acciones</th>
                          </tr>
                        </thead>
                        <tbody class="bg-white divide-y divide-gray-200">
                          <tr v-for="item in list" :key="item.id">
                            <td class="text-left align-middle">
                              {{ dateConvert(item.created_at) }}
                            </td>

                            <td v-if="item.hygiene_service === 'Otros ¿cuáles?'" class="text-left align-middle">
                              {{ item.other }}
                            </td>
                            <td v-else class="text-left align-middle">
                              {{ item.hygiene_service }}
                            </td>

                            <td class="text-center align-middle">
                              <div v-if="item.file === null">
                                <h6>No hay archivo disponible</h6>
                              </div>
                              <div v-else>
                                <button :disabled="!allowAccess()" style="
                                    background-color: transparent !important;
                                    border: none;
                                  " type="button" @click="gotoDigitalOcean(`${item.file}`)">
                                  <i class="mdi mdi-cloud-download"></i>
                                </button>
                              </div>
                            </td>
                            <td class="text-center align-middle">
                              <div class="col-sm-12">
                                <b-dropdown variant="primary" :disabled="!allowAccess() || !getRole('Editar')
                                  ">
                                  <template v-slot:button-content>
                                    <i class="mdi mdi-eye"></i>
                                  </template>
                                  <b-dropdown-item :disabled="!allowAccess() || !getRole('Editar')
                                    " v-b-modal="`modal${item.id}`">
                                    Editar
                                  </b-dropdown-item>
                                  <b-modal :id="`modal${item.id}`" body-class="p-4" hide-header hide-footer size="sm">
                                    <div class="text-justify">
                                      <h4 class="mt-2 text-primary text-center">
                                        Advertencia
                                      </h4>
                                      <p class="mt-3">
                                        Al modificar esta información se quitará
                                        el puntaje correspondiente a este ítem y
                                        será necesario realizar nuevamente la
                                        validación por parte del usuario
                                        responsable de Emisión.
                                      </p>
                                      <button type="button" @click="
                                        goPage(
                                          `/forms/estandares/servicios-higiene-editar/${item.id}`
                                        )
                                        " class="btn btn-primary my-2 mx-2" data-dismiss="`modal${item.id}`"
                                        :disabled="!allowAccess()">
                                        Continuar
                                      </button>
                                      <button type="button" @click="
                                        $bvModal.hide(`modal${item.id}`)
                                        " class="btn btn-danger btn mx-2" data-dismiss="modal">
                                        Cancelar
                                      </button>
                                    </div>
                                  </b-modal>
                                  <b-dropdown-item :disabled="!allowAccess() || !getRole('Editar')
                                    " :to="{
                                      path: `/forms/estandares/servicios-higiene-ver/${item.id}`,
                                    }">
                                    Ver
                                  </b-dropdown-item>
                                  <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()
                                    " v-on:click="deleteEliminacion(item.id)">Eliminar</b-dropdown-item>
                                </b-dropdown>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <ServiciosHigienePagination ref="paginator" @loading="(load) => (loading = load)" :search="search"
                        @fetch="(items) => (list = items)" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>

        <!-- end card -->
      </div>
    </div>
    <!--- end row -->
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
